export const ACADEMIC_GALLERY=[
  {
    "displayText": "1",
    "filename": "./assets/img/gallery/academic/1.jpg",
    "link": ""
  },
  {
    "displayText": "10",
    "filename": "./assets/img/gallery/academic/10.jpg",
    "link": ""
  },
  {
    "displayText": "11",
    "filename": "./assets/img/gallery/academic/11.jpg",
    "link": ""
  },
  {
    "displayText": "12",
    "filename": "./assets/img/gallery/academic/12.jpg",
    "link": ""
  },
  {
    "displayText": "13",
    "filename": "./assets/img/gallery/academic/13.jpg",
    "link": ""
  },
  {
    "displayText": "14",
    "filename": "./assets/img/gallery/academic/14.jpg",
    "link": ""
  },
  {
    "displayText": "15",
    "filename": "./assets/img/gallery/academic/15.jpg",
    "link": ""
  },
  {
    "displayText": "16",
    "filename": "./assets/img/gallery/academic/16.jpg",
    "link": ""
  },
  {
    "displayText": "17",
    "filename": "./assets/img/gallery/academic/17.jpg",
    "link": ""
  },
  {
    "displayText": "18",
    "filename": "./assets/img/gallery/academic/18.jpg",
    "link": ""
  },
  {
    "displayText": "19",
    "filename": "./assets/img/gallery/academic/19.jpg",
    "link": ""
  },
  {
    "displayText": "2",
    "filename": "./assets/img/gallery/academic/2.jpg",
    "link": ""
  },
  {
    "displayText": "20",
    "filename": "./assets/img/gallery/academic/20.JPG",
    "link": ""
  },
  {
    "displayText": "3",
    "filename": "./assets/img/gallery/academic/3.jpg",
    "link": ""
  },
  {
    "displayText": "4",
    "filename": "./assets/img/gallery/academic/4.jpg",
    "link": ""
  },
  {
    "displayText": "5",
    "filename": "./assets/img/gallery/academic/5.jpg",
    "link": ""
  },
  {
    "displayText": "6",
    "filename": "./assets/img/gallery/academic/6.jpg",
    "link": ""
  },
  {
    "displayText": "7",
    "filename": "./assets/img/gallery/academic/7.jpg",
    "link": ""
  },
  {
    "displayText": "8",
    "filename": "./assets/img/gallery/academic/8.jpg",
    "link": ""
  },
  {
    "displayText": "9",
    "filename": "./assets/img/gallery/academic/9.jpg",
    "link": ""
  },
  {
    "displayText": "BLOOD SUGAR DETECTION",
    "filename": "./assets/img/gallery/academic/BLOOD SUGAR DETECTION.jpg",
    "link": ""
  },
  {
    "displayText": "CPR AWEARNESS PROGRAMME",
    "filename": "./assets/img/gallery/academic/CPR AWEARNESS PROGRAMME.jpg",
    "link": ""
  },
  {
    "displayText": "HOSPITAL VISIT",
    "filename": "./assets/img/gallery/academic/HOSPITAL VISIT.jpeg",
    "link": ""
  },
  {
    "displayText": "MEDICINAL GARDEN VISIT",
    "filename": "./assets/img/gallery/academic/MEDICINAL GARDEN VISIT.jpeg",
    "link": ""
  },
  {
    "displayText": "PHARMACIST DAY RALLY",
    "filename": "./assets/img/gallery/academic/PHARMACIST DAY RALLY.jpeg",
    "link": ""
  },
  {
    "displayText": "PHARMACIST DAY",
    "filename": "./assets/img/gallery/academic/PHARMACIST DAY.jpg",
    "link": ""
  },
  {
    "displayText": "TREE PLANTATION 2",
    "filename": "./assets/img/gallery/academic/TREE PLANTATION 2.jpeg",
    "link": ""
  },
  {
    "displayText": "TREE PLANTATION",
    "filename": "./assets/img/gallery/academic/TREE PLANTATION.jpeg",
    "link": ""
  }
]